<div class="flex grow flex-col">
  <app-topbar></app-topbar>
  <p-drawer [(visible)]="isSidebarVisible" styleClass="!w-full md:!w-80 lg:!w-[30rem]">
    <ng-template #header>
      <img src="./assets/logo.png" />
    </ng-template>
    <p-panelMenu [model]="menuLinks"></p-panelMenu>
  </p-drawer>

  <div class="layout-main-container mt-20 flex flex-col">
      <router-outlet></router-outlet>
  </div>
</div>
